module.exports = __webpack_public_path__ + "img/wood.b92c31f3.png";